import {SET_ACTIVE_ANNOTATION, UNSET_ACTIVE_ANNOTATION} from '../../actions/actiontypes';
import initialstate from '../initialstate';

export default function activeAnnotationReducer(state = initialstate.activeAnnotation, action) {
	switch (action.type) {
		case SET_ACTIVE_ANNOTATION: {
			const {activeAnnotationId} = action.data;

			return activeAnnotationId;
		}
		case UNSET_ACTIVE_ANNOTATION: {
			return null;
		}
		default:
			return state;
	}
}
